import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface ICancelTrip {
  execute(loteId: number): Promise<void>
}

export default class ICancelTripImpl implements ICancelTrip {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute(loteId: number): Promise<void> {
    await this.loteSolicitadoRepository.cancelTrip(loteId)
  }
}
